<template>
  <div class="preloader">
    <div class="preloader-animation">
      <div class="preloader-spinner"></div>
    </div>
  </div>
</template>

<script>
import { onMounted } from 'vue'

export default {
  name: 'Preloader',
  setup() {
    onMounted(() => {
      setTimeout(() => {
        $('.preloader').fadeOut(800, 'linear')
      }, 2000)
    })
  }
}
</script>
